import React, { useState, useEffect, useCallback } from "react";

interface Props {
  delayedUntil: Date;
  onComplete?: () => void;
}

export default function JobTimer({ delayedUntil, onComplete }: Props) {
  const calculateTimeLeft = useCallback(() => {
    if (!delayedUntil) return 0;
    const now = new Date();
    const delayDate = new Date(delayedUntil);
    const difference = delayDate.getTime() - now.getTime();
    return Math.max(0, Math.floor(difference / 1000));
  }, [delayedUntil]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const intervalId = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      if (newTimeLeft === 0 && onComplete) {
        onComplete();
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [delayedUntil, calculateTimeLeft, onComplete]);

  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete?.();
    }
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;

  return <div className="text-sm">{`${minutes}:${seconds < 10 ? "0" : ""}${seconds}`}</div>;
}
